import { observable } from 'mobx';
var schemaVersion = 3;
var globalObject = (typeof globalThis !== 'undefined'
    ? globalThis
    : typeof window !== 'undefined'
        ? window
        : global);
export function __resetGlobalContext() {
    globalObject.__satchelGlobalContext = {
        schemaVersion: schemaVersion,
        rootStore: observable.map({}),
        nextActionId: 0,
        subscriptions: {},
        dispatchWithMiddleware: null,
        currentMutator: null,
        legacyInDispatch: 0,
        legacyDispatchWithMiddleware: null,
        legacyTestMode: false,
    };
}
export function ensureGlobalContextSchemaVersion() {
    if (schemaVersion != globalObject.__satchelGlobalContext.schemaVersion) {
        throw new Error('Detected incompatible SatchelJS versions loaded.');
    }
}
export function getGlobalContext() {
    return globalObject.__satchelGlobalContext;
}
if (!globalObject.__satchelGlobalContext) {
    __resetGlobalContext();
}
else {
    ensureGlobalContextSchemaVersion();
}
